import React, {useEffect} from "react";
import {getDocumentTitle} from "../../utils/documentTitle";
import {AktuelleSaker} from "../../components/Saker/AktuelleSaker";
import {AvsluttedeSaker} from "../../components/Saker/AvsluttedeSaker";

export function DineSaker() {
    useEffect(() => {
        window.scrollTo(0, 0)
        document.title = getDocumentTitle("dine-saker")
    })

    return (
        <div className="pkt-cell pkt-cell--span12">
            <div
                className="my-size-24 mt-size-64--tablet-up mb-size-40--tablet-up">
                <h1 className="pkt-txt-36 pkt-txt-40--tablet-up">
                    Dine saker
                </h1>
                <p className={"pkt-txt-18-light mb-size-50"}>
                    Gå inn på en sak for å se innholdet og hvilke valg du har tilgjengelig.
                </p>

                <div className={"mb-size-50"}>
                    <AktuelleSaker/>
                </div>
                <AvsluttedeSaker/>
            </div>
        </div>
    )
}

